import clsx from 'clsx';
import { m, LazyMotion, domAnimation } from 'framer-motion';
import PropTypes from 'prop-types';
import React from 'react';

const ANIMATION_DURATION = 0.2;

const Burger = ({ className, isToggled, onClick }) => (
  <LazyMotion features={domAnimation}>
    <m.button
      className={clsx(
        'relative h-10 w-10 flex-col justify-center items-center gap-[5px]',
        className
      )}
      type="button"
      animate={isToggled ? 'toggled' : 'initial'}
      aria-label="Menu"
      onClick={onClick}
    >
      <m.span
        className="block h-0.5 w-6 rounded-full bg-black"
        variants={{
          initial: {
            rotate: 0,
            translateY: 0,
            transition: {
              rotate: { duration: ANIMATION_DURATION },
              translateY: { duration: ANIMATION_DURATION, delay: ANIMATION_DURATION },
            },
          },
          toggled: {
            rotate: 45,
            translateY: 7,
            transition: {
              rotate: { duration: ANIMATION_DURATION, delay: ANIMATION_DURATION },
              translateY: { duration: ANIMATION_DURATION },
            },
          },
        }}
      />
      <m.span
        className="block h-0.5 w-6 rounded-full bg-black"
        variants={{
          initial: {
            opacity: 1,
            transition: { duration: ANIMATION_DURATION },
          },
          toggled: {
            opacity: 0,
            transition: { duration: ANIMATION_DURATION },
          },
        }}
      />
      <m.span
        className="block h-0.5 w-6 rounded-full bg-black"
        variants={{
          initial: {
            rotate: 0,
            translateY: 0,
            transition: {
              rotate: { duration: ANIMATION_DURATION },
              translateY: { duration: ANIMATION_DURATION, delay: ANIMATION_DURATION },
            },
          },
          toggled: {
            rotate: -45,
            translateY: -7,
            transition: {
              rotate: { duration: ANIMATION_DURATION, delay: ANIMATION_DURATION },
              translateY: { duration: ANIMATION_DURATION },
            },
          },
        }}
      />
    </m.button>
  </LazyMotion>
);

Burger.propTypes = {
  className: PropTypes.string,
  isToggled: PropTypes.bool,
  onClick: PropTypes.func,
};

Burger.defaultProps = {
  className: null,
  isToggled: false,
  onClick: null,
};

export default Burger;
